module.exports = __webpack_public_path__ + "img/cuff_width.4e680f0d.png";